import React from 'react'
import { ScrollView, View } from 'react-native'
import { TopNavigationBar } from 'ui/common/top-navigation-bar'
import { colors } from 'infra/color'
import { observer } from 'mobx-react'
import { useSafeAreaInsets } from 'infra/util'
import { Body2, ButtonText } from 'ui/common/text'
import { RowLayout } from 'ui/common/layout'
import { CategoryChip } from 'ui/discovery/category-chip'
import { BottomButton } from 'ui/discovery/bottom-button'
import styled from 'styled-components'
import { categorySelectStore } from 'store/category-select'
import { navigation } from 'navigation/global'

export const CategorySelectScreen = observer(() => {
  const safeAreaInsets = useSafeAreaInsets()
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: colors.white,
        paddingTop: safeAreaInsets.top,
      }}
    >
      <TopNavigationBar title='카테고리로 탐색' />
      <ScrollView
        style={{
          paddingTop: 16,
          paddingHorizontal: 30,
        }}
      >
        <Body2 style={{ color: colors.gray.v600, marginBottom: 12 }}>
          1차 카테고리
        </Body2>
        <RowLayout style={{ flexWrap: 'wrap' }}>
          {categorySelectStore.data.map((x) => (
            <CategoryChip
              key={x.id}
              isActive={false}
              isSelected={categorySelectStore.checkIsL1CategorySelected(x)}
              data={x}
              onPress={() => {
                categorySelectStore.selectL1Category(x)
              }}
            />
          ))}
        </RowLayout>
        {categorySelectStore.l2CategoriesToShow.length > 0 && (
          <Body2
            style={{ color: colors.gray.v600, marginBottom: 12, marginTop: 16 }}
          >
            2차 카테고리
          </Body2>
        )}
        <RowLayout style={{ flexWrap: 'wrap' }}>
          {categorySelectStore.l2CategoriesToShow.map((x) => (
            <CategoryChip
              key={x.id}
              isActive={true}
              isSelected={categorySelectStore.checkIsL2CategorySelected(x)}
              data={x}
              onPress={() => {
                categorySelectStore.selectL2Category(x)
              }}
            />
          ))}
        </RowLayout>
        <View style={{ height: safeAreaInsets.bottom + 32 + 100 }} />
      </ScrollView>
      <BottomButtonContainer
        style={{ bottom: safeAreaInsets.bottom + 32 }}
        pointerEvents='box-none'
      >
        <BottomButton
          onPress={() => navigation.navigate('CategoryDiscoveryScreen')}
        >
          <ButtonText>탐색</ButtonText>
        </BottomButton>
      </BottomButtonContainer>
    </View>
  )
})

const BottomButtonContainer = styled(View)`
  position: absolute;
  width: 100%;
  align-items: center;
`
